<div class="page__section">
    <div class="container">
        <div class="grid__layout">
            <div class="row">
                <div class="col">
                    <h1>Your viewing for {{viewing.propertySummary.address.singleLine}}<ng-container *ngIf="viewing.roomSummary"> ({{viewing.roomSummary.name}})</ng-container> is confirmed!</h1>
                    <p *ngIf="!viewing.applicantViewingConfirmed">You will receive another confirmation request 2 hours before the viewing date.</p>
                </div>
            </div>
        </div>
    </div>
</div>

